import { createFileRoute } from "@tanstack/react-router";
import { LetterEditorPage } from "@/components/notices/editor/letter-editor-page";

export const Route = createFileRoute("/_authenticated/notices/$id/edit")({
  component: LetterEditorRoute,
});

/** One letter's editing surface — full-bleed (see notices.tsx). */
function LetterEditorRoute() {
  const { id } = Route.useParams();
  return <LetterEditorPage noticeId={id} />;
}
